export function offerTabsInit() {
    const $tabs = document.querySelectorAll(".offer-tabs__item");
    const $lists = document.querySelectorAll(".offer-items");

    if (!$tabs.length || !$lists.length) return;

    $tabs.forEach(($tab) => {
        $tab.addEventListener("click", () => {
            if ($tab.classList.contains("offer-tabs__item--active")) return;

            const idx = Number($tab.dataset.tabIdx);

            $tabs.forEach(($item) => $item.classList.toggle("offer-tabs__item--active", $item === $tab));
            $lists.forEach(($list) => $list.classList.toggle("offer-items--active", Number($list.dataset.listIdx) === idx));
        });
    });
}
